import { useTheme } from 'styled-components';

import HeroThumbnail from '../../assets/images/hero-thumbnail.png';
import { Button, Flex, Typography } from '../../designComponents';
import YoutubeVideoEmbed from '../../designComponents/YoutubeVideoEmbed';
import { HeroSectionStyled } from './landing-styles';

const HeroSection = () => {
  const theme = useTheme();

  return (
    <HeroSectionStyled>
      <Typography strong className="hero-title">
        <span style={{ color: theme.colors.blueLight }}>
          Professional Blueprint
        </span>
        &nbsp; Services - Bringing Your&nbsp;
        <span style={{ color: theme.colors.primary }}>Building Plans</span> to
        Life
      </Typography>

      <Typography size={16} className="hero-desc">
        Unlock the potential of your architectural vision with our expert
        blueprint services. From concept to completion, our team specializes in
        translating your building plans into precise, detailed blueprints.
      </Typography>
      <Flex justifyContent="center" margin="0px 0px 50px">
        <Button style={{ borderRadius: '28px', padding: '6px 16px' }}>
          GET STARTED
        </Button>
      </Flex>

      <YoutubeVideoEmbed
        thumbnailImgURL={HeroThumbnail}
        videoPath="/bannerVideo.mp4"
      />
    </HeroSectionStyled>
  );
};

export default HeroSection;
